export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    checkScrollBug();
    setInterval(function(){
      checkScrollBug();
    }, 1000);

    setTimeout(checkScrollBug, 100);

    window.onYouTubeIframeAPIReady = function() {

      const spottVideos = document.querySelectorAll('[data-spott-video-id]');

      spottVideos.forEach(function(item){

        // const player = new window.YT.Player(item);
        const player = new window.YT.Player(item, {
          videoId: item.getAttribute('data-video-id'),
          playerVars: {
            'autoplay': 0,
            'controls': 1,
            'autohide': 0,
            'wmode': 'opaque',
          },
        });

        const spottID = item.getAttribute('data-spott-video-id');
        window.initSpottYouTube(player, {
          videoId: spottID,
        });

      });


    };

  },
};

$( document ).ready(function() {
  $('.nav-footer ul li:nth-child(2)').after('<li><a class="'+$('#ot-sdk-btn').attr('class')+'">' + $('#ot-sdk-btn').html() + '</a></li>');
  $('#ot-sdk-btn').hide();
});

let checkScrollBug = function(){
  if(window.scrollX > 0){
    window.scrollTo(0, window.scrollY);
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js